import {createAction} from 'redux-act'

export const setTransferTradesApiModalVisible = createAction('SET_TRANSFER_TRADES_API_MODAL_VISIBLE')
export const setTransferTradesApiForm = createAction('SET_TRANSFER_TRADES_API_FORM')
export const closeTransferTradesApiForm = createAction('CLOSE_TRANSFER_TRADES_API_FORM')
export const setTransferTradesApiNotificationIds = createAction('SET_TRANSFER_TRADES_API_NOTIFICATIONS_IDS')
